import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../../layout/Box';
import ResumableBox from '../ResumableBox'
import './styles.scss';


class UploadTray extends React.Component{

  constructor(props){
    super(props);
  }

  renderError(error){
    if(error.status && error.status > 400){
      return 'Permission denied.'
    }
    return error
  }

  checkRender(visible, uploads, resumableUploads){
    return (
      <React.Fragment>
        {
          uploads.map((upload, index) => (
            <Box
              key={index}
              direction="column"
              className={
                classNames('upload', `${visible ? '': 'd-none'}`, 'callout', {
                  alert: upload.failed,
                  success: !upload.failed,
              })}
            >
              <span className="file-name small">{upload.file.name}</span>
              {upload.progress && <progress value={upload.progress.toFixed(2)} max={100}/>}
              {upload.failed && <div>Error: {this.renderError(upload.error)}</div>}
            </Box>
          ))
        }
        <ResumableBox visible={!visible}/>
        </React.Fragment>
    )
  }

  render(){
    const { uploads, resumableUploads, visible, toggleVisibility } = this.props;
    return (
      <Box>
        <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
          <button title={`${visible ? 'Monitor your Resumable uploads, you can pause, continue or abort an upload.': 'View Standard uploads'}`} className='button' onClick={toggleVisibility}>
            {visible ? 'View Resumable Uploads' : 'View Standard Uploads'}
          </button>
          {this.checkRender(visible, uploads, resumableUploads)}
        </div>
      </Box>
    )
  }
}


UploadTray.propTypes = {
  uploads: PropTypes.array,
  resumableUploads: PropTypes.array,
  visible: PropTypes.bool.isRequired,
  toggleVisibility: PropTypes.func.isRequired
};

export default UploadTray;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/UploadTray/index.js